export const isAdmin = () => {
  const path = window.location.pathname;
  return path.includes('admin');
};
